module.exports = __webpack_public_path__ + "static/media/permis-conduire.fe14418e.svg";